// @flow
const POPOVER_DIRECTIONS = {
  horizontal: ['before', 'after', 'left', 'center', 'right'],
  vertical: ['above', 'below', 'top', 'middle', 'bottom'],
};

export default POPOVER_DIRECTIONS;



// WEBPACK FOOTER //
// ./src/scripts/components/Closeable/Popover/directions.jsx